import type { SVGAttributes } from "react";

export function SearchIcon({
  className,
  height,
  width,
  fill,
}: SVGAttributes<unknown>) {
  return (
    <>
      <svg
        className={className}
        width={width}
        height={height}
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <defs></defs>
        <g id="Group_1085" data-name="Group 1085">
          <g id="Ellipse_68" data-name="Ellipse 68">
            <circle style={{ fill: "none" }} cx="8.31" cy="7.83" r="7.72" />
            <path
              fill={fill}
              d="M8.31,15.57a7.74,7.74,0,1,1,7.74-7.74A7.75,7.75,0,0,1,8.31,15.57Zm0-14.48a6.74,6.74,0,1,0,6.74,6.74A6.74,6.74,0,0,0,8.31,1.09Z"
            />
          </g>
          <path
            fill={fill}
            d="M18.93,19.91a.5.5,0,0,1-.35-.14L12.78,14a.5.5,0,0,1,0-.7.5.5,0,0,1,.71,0l5.79,5.79a.5.5,0,0,1,0,.71A.52.52,0,0,1,18.93,19.91Z"
          />
        </g>
      </svg>
    </>
  );
}
